module.exports = __webpack_public_path__ + "static/media/xlsx.0bc0712b.png";